// Scoring and calculation utilities

export function calculateWeightedScore(performanceAreas) {
  let totalWeightedScore = 0;
  let totalWeight = 0;

  performanceAreas.forEach(area => {
    const score = area.managerScore !== undefined ? area.managerScore : area.employeeScore;
    if (score !== undefined) {
      totalWeightedScore += score * area.weight;
      totalWeight += area.weight;
    }
  });

  return totalWeight > 0 ? totalWeightedScore / totalWeight : 0;
}

export function calculateEmployeeSelfScore(performanceAreas) {
  let totalWeightedScore = 0;
  let totalWeight = 0;

  performanceAreas.forEach(area => {
    if (area.employeeScore !== undefined) {
      totalWeightedScore += area.employeeScore * area.weight;
      totalWeight += area.weight;
    }
  });

  return totalWeight > 0 ? totalWeightedScore / totalWeight : 0;
}

export function calculateManagerScore(performanceAreas) {
  let totalWeightedScore = 0;
  let totalWeight = 0;

  performanceAreas.forEach(area => {
    if (area.managerScore !== undefined) {
      totalWeightedScore += area.managerScore * area.weight;
      totalWeight += area.weight;
    }
  });

  return totalWeight > 0 ? totalWeightedScore / totalWeight : 0;
}

export function calculateProgress(appraisal) {
  let completed = 0;
  let total = 3; // Performance Areas, Goals, Comments

  // Check performance areas
  const allAreasComplete = appraisal.performanceAreas?.every(area => 
    area.employeeScore !== undefined || area.completedByEmployee
  );
  if (allAreasComplete) completed++;

  // Check goals
  const hasGoals = appraisal.goals?.current?.length > 0 || appraisal.goals?.future?.length > 0;
  if (hasGoals) completed++;

  // Comments are optional but count if present
  if (appraisal.comments?.employee) completed++;

  return Math.round((completed / total) * 100);
}

export function getScoreLabel(score) {
  if (score === undefined || score === null) return 'N/A';
  if (score <= 1) return 'Needs Improvement';
  if (score <= 2) return 'Below Expectations';
  if (score <= 3) return 'Meets Expectations';
  if (score <= 4) return 'Exceeds Expectations';
  return 'Outstanding';
}

export function getScoreColor(score) {
  if (score === undefined || score === null) return 'text-gray-400';
  if (score <= 1) return 'text-red-500';
  if (score <= 2) return 'text-orange-500';
  if (score <= 3) return 'text-yellow-500';
  if (score <= 4) return 'text-teal-500';
  return 'text-emerald-500';
}

export function getStatusBadgeColor(status) {
  switch (status) {
    case 'draft': return 'bg-gray-100 text-gray-700';
    case 'ready_to_evaluate': return 'bg-blue-100 text-blue-700';
    case 'employee_completed': return 'bg-amber-100 text-amber-700';
    case 'manager_review': return 'bg-purple-100 text-purple-700';
    case 'sent_to_ceo': return 'bg-indigo-100 text-indigo-700';
    case 'finalized': return 'bg-emerald-100 text-emerald-700';
    default: return 'bg-gray-100 text-gray-700';
  }
}

export function formatStatus(status) {
  switch (status) {
    case 'draft': return 'Draft';
    case 'ready_to_evaluate': return 'Ready to Evaluate';
    case 'employee_completed': return 'Pending Manager Review';
    case 'manager_review': return 'Manager Reviewing';
    case 'sent_to_ceo': return 'Pending CEO Review';
    case 'finalized': return 'Finalized';
    default: return status;
  }
}

export function calculateVariance(employeeScore, managerScore) {
  if (employeeScore === undefined || managerScore === undefined) return null;
  return Math.abs(employeeScore - managerScore);
}

export function hasSignificantVariance(employeeScore, managerScore, threshold = 1) {
  const variance = calculateVariance(employeeScore, managerScore);
  return variance !== null && variance > threshold;
}
